import i18n from "i18next";
import { getLocalStorage } from "@shared/lib/localStorageUtils";
import { initReactI18next } from "react-i18next";
import bgTranslations from "@shared/i18n/locales/bg.json";
import enTranslations from "@shared/i18n/locales/en.json";

const savedLanguage = getLocalStorage("selectedLanguage") || "bg";

i18n
  .use(initReactI18next)
  .init({
    lng: savedLanguage as string,
    fallbackLng: "bg",
    debug: true,
    interpolation: {
      escapeValue: false,
    },
    resources: {
      bg: { translation: bgTranslations },
      en: { translation: enTranslations },
    },
  });

export default i18n;
